<h3>
    <i ng-show="item.Status===1" class="ng-hide fa fa-cog fa-spin fa-fw"></i><a ng-click="viewDetails($event, item)" ng-bind-html="item.name|cHighlight:highlight"></a> <span ng-if="item.Updated" class="fa fa-check" style="color: green"></span>
</h3>
<div class="description" ng-bind="item.description"></div>
<div class="property-container">
    <ul class="workflow-property-list">
        <li ng-repeat="prop in item.properties" ng-bind-html="prop|cHighlight:highlight"></li>
    </ul>
</div>